var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconExternallink24 = function SvgAIconExternallink24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "aria-hidden": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9996 8.19975V4H13.7998",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 4L8.66699 13.3328",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65793 6.80013H4.93328C4.68576 6.80013 4.44837 6.89845 4.27335 7.07348C4.09833 7.2485 4 7.48588 4 7.7334V17.0662C4 17.3137 4.09833 17.5511 4.27335 17.7261C4.44837 17.9011 4.68576 17.9995 4.93328 17.9995H14.2661C14.5136 17.9995 14.751 17.9011 14.926 17.7261C15.101 17.5511 15.1993 17.3137 15.1993 17.0662V12.3415",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconExternallink24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGQ9Ik0xNy45OTk2IDguMTk5NzVWNEgxMy43OTk4IiBzdHJva2Utd2lkdGg9IjEuOCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBkPSJNMTcuOTk5OCA0TDguNjY2OTkgMTMuMzMyOCIgc3Ryb2tlLXdpZHRoPSIxLjgiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTkuNjU3OTMgNi44MDAxM0g0LjkzMzI4QzQuNjg1NzYgNi44MDAxMyA0LjQ0ODM3IDYuODk4NDUgNC4yNzMzNSA3LjA3MzQ4QzQuMDk4MzMgNy4yNDg1IDQgNy40ODU4OCA0IDcuNzMzNFYxNy4wNjYyQzQgMTcuMzEzNyA0LjA5ODMzIDE3LjU1MTEgNC4yNzMzNSAxNy43MjYxQzQuNDQ4MzcgMTcuOTAxMSA0LjY4NTc2IDE3Ljk5OTUgNC45MzMyOCAxNy45OTk1SDE0LjI2NjFDMTQuNTEzNiAxNy45OTk1IDE0Ljc1MSAxNy45MDExIDE0LjkyNiAxNy43MjYxQzE1LjEwMSAxNy41NTExIDE1LjE5OTMgMTcuMzEzNyAxNS4xOTkzIDE3LjA2NjJWMTIuMzQxNSIgc3Ryb2tlLXdpZHRoPSIxLjgiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPC9zdmc+";